import http from "../utility/http";

/**
 * GET claims report via backend proxy (avoids CORS). Backend calls bigboyserver.ca with Bearer token.
 * @param {string} startDate - YYYY-MM-DD
 * @param {string} endDate - YYYY-MM-DD
 * @returns {Promise<Array>} Array of claim objects
 */
const getClaimsReport = async (startDate, endDate) => {
  const result = await http.get(
    `/v1/uv-claims-report?start_date=${encodeURIComponent(startDate)}&end_date=${encodeURIComponent(endDate)}`
  );
  if (result.error) {
    throw new Error(result.message || "Failed to load UV claims.");
  }
  const data = result.data ?? result.responseData?.data?.data;
  return Array.isArray(data) ? data : data?.data ?? [];
};

export default {
  getClaimsReport,
};
